import React, { useEffect, useState } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";

/**
 * A soft gold spotlight + small dot that trail the pointer (desktop only).
 * Keeps the native cursor; mix-blend-screen makes the glow read on obsidian.
 */
export default function SpotlightCursor() {
  const x = useMotionValue(-200);
  const y = useMotionValue(-200);
  const glowX = useSpring(x, { stiffness: 120, damping: 20, mass: 0.6 });
  const glowY = useSpring(y, { stiffness: 120, damping: 20, mass: 0.6 });
  const dotX = useSpring(x, { stiffness: 500, damping: 30, mass: 0.3 });
  const dotY = useSpring(y, { stiffness: 500, damping: 30, mass: 0.3 });
  const [active, setActive] = useState(false);
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (window.matchMedia("(pointer: coarse)").matches) return;
    setEnabled(true);
    const move = (e) => {
      x.set(e.clientX);
      y.set(e.clientY);
      const t = e.target;
      setActive(!!(t.closest && t.closest("a,button,[role='button'],input,select,textarea,[data-magnetic]")));
    };
    window.addEventListener("pointermove", move);
    return () => window.removeEventListener("pointermove", move);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!enabled) return null;

  return (
    <>
      <motion.div
        aria-hidden
        className="pointer-events-none fixed top-0 left-0 z-[9998] hidden lg:block"
        style={{ x: glowX, y: glowY, willChange: "transform" }}
      >
        <div
          className="-translate-x-1/2 -translate-y-1/2 rounded-full"
          style={{
            width: active ? 460 : 320,
            height: active ? 460 : 320,
            background: "radial-gradient(circle, rgba(212,175,55,0.12), rgba(212,175,55,0.04) 40%, transparent 65%)",
            mixBlendMode: "screen",
            transition: "width .5s ease, height .5s ease",
          }}
        />
      </motion.div>
      <motion.div
        aria-hidden
        className="pointer-events-none fixed top-0 left-0 z-[9999] hidden lg:block"
        style={{ x: dotX, y: dotY, willChange: "transform" }}
      >
        <div
          className="-translate-x-1/2 -translate-y-1/2 rounded-full border border-[#D4AF37]"
          style={{
            width: active ? 36 : 8,
            height: active ? 36 : 8,
            background: active ? "transparent" : "#D4AF37",
            opacity: active ? 0.8 : 0.9,
            transition: "width .3s ease, height .3s ease, background .3s ease",
          }}
        />
      </motion.div>
    </>
  );
}
